import { render } from "./ConnectedSearch.vue?vue&type=template&id=0a58abf5"
import script from "./ConnectedSearch.vue?vue&type=script&lang=js"
export * from "./ConnectedSearch.vue?vue&type=script&lang=js"

import "./ConnectedSearch.vue?vue&type=style&index=0&id=0a58abf5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__